import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=4af6975a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6975a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af6975a')) {
      api.createRecord('4af6975a', component.options)
    } else {
      api.reload('4af6975a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=4af6975a&scoped=true&", function () {
      api.rerender('4af6975a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/comp/SearchFilterTokens.vue"
export default component.exports